

















import {
  computed,
  defineComponent,
  onUnmounted,
  ref,
} from '@vue/composition-api';

const MAX_COUNT = 3;

export default defineComponent({
  setup(_, { root }) {
    const alerts = ref<any>([]);
    const hidden = ref(false);

    const hentikan = root.$store.subscribe(({ type, payload }, state) => {
      if (type.startsWith('notifikasi')) {
        //do your stuff here
        if (type.endsWith('aturNotifikasi')) {
          alerts.value = [...alerts.value, payload.pesan];
        } else if (type.endsWith('hapusNotifikasi')) {
          const alert = [...alerts.value];
          alert.pop();
          alerts.value = alert;
        }
      }
    });

    const displayAlert = computed(() => {
      return hidden.value ? [] : alerts.value.slice(0, MAX_COUNT);
    });
    const disable = () => (hidden.value = true);
    const enable = () => (hidden.value = false);

    onUnmounted(() => {
      hentikan();
    });

    return {
      displayAlert,
      disable,
      enable,
      hidden,
    };
  },
});
